import { render, staticRenderFns } from "./overhaulmaterials.vue?vue&type=template&id=4202a0e4"
import script from "./overhaulmaterials.vue?vue&type=script&lang=js"
export * from "./overhaulmaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./overhaulmaterials.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports